import React from "react";
import { UserSettings as UserSettingsComponent } from "../components/user/UserSettings";

const UserSettings = () => {
  return <UserSettingsComponent />;
};

export default UserSettings;
